<div class="container-fluid mt-3">
  <div class="row justify-content-center">
    <div class="col-12 align-self-center">
      <h4 class="mb-0">Tworzenie kategorii</h4>
    </div>
  </div>
</div>
<div class="container-fluid mt-3 mb-3">
  <div class="row justify-content-center">
    <div class="col-12">
      <mat-divider></mat-divider>
    </div>
  </div>
</div>
<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="row justify-content-center">
        <form #createCategory="ngForm">
          <div class="col-12">
            <mat-form-field appearance="fill" color="accent" class="w-100">
              <mat-label>Nazwa kategorii</mat-label>
              <textarea rows="5" name="nameCategory" matInput [(ngModel)]="keyNameCategory"></textarea>
            </mat-form-field>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12">
      <button [disabled]="!keyNameCategory" mat-raised-button class="btn-success rounded-0 mx-auto d-block" (click)="create(createCategory)">Utwórz</button>
    </div>
  </div>
</div>
